import {updateEmailStatus} from '../../../redux/branding/brandingActions';
import {updateEventSettings} from '../../../redux/event/eventActions';
import setGlobalState from '../../../redux/setGlobalState';
import {getState} from '../../../redux/store.type';
import {MESSAGE_TYPES} from '../../branding/menu/brandingConfig';

export const updateNotification = async (setting) => {
    let XHR = null;
    setGlobalState('forms.eventSettings.notificationXHR', 'LOADING');
    if(!setting) {
        XHR = await updateEventSettings('smsSend', true, 'report');
    }
    else {
        XHR = await updateEventSettings('smsSend', false, 'report');
        await updateEventSettings('emailSend', false, 'report');
    }
    setGlobalState('forms.eventSettings.notificationXHR', XHR);
};

export const updateFullSend = async (name,report,setting) => {
    if(setting&&name==='fullSend'&&!(report.reportToEmail||report.reportToWhatsapp)){
        await updateEventSettings('fullSend', true, 'report');
        await updateEventSettings('reportToEmail', true, 'report');
        return;
    }
    await updateEventSettings(name,setting,'report');
};

export const updateMonthlyError = async (setting) => {
    setGlobalState('event.settings.report.monthlyError', !setting);
    if(setting){
        await updateEventSettings('monthlyErrorSms', false, 'report');
        await updateEventSettings('monthlyErrorEmail', false, 'report');
    }
};

export const updateWhatsAppMessageSetting = async (setting, messageType) => {
    messageType = messageType || MESSAGE_TYPES.sendTicket;
    const lang = getState().branding?.currentLang || getState().event.lang || 'he';
    try {
        await updateEventSettings('whatsAppMessage', {active: !setting, messageType, lang}, 'ticketsMailing');
        await updateEmailStatus('enabledWhatsapp', setting ? 0 : 1, messageType);
    } catch (error) {
        console.log('Failed to update WhatsApp purchase message setting:', error);
    }
};